import React, { useRef } from 'react';
import { SwiperArrowLeftIcon, SwiperArrowRightIcon } from 'icons';
import { useTranslations } from 'next-intl';
import { Autoplay, FreeMode, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import { useFeedbacks } from 'modules/pro';

import { Card } from './card';

export const Feedbacks = () => {
  const { feedbacks } = useFeedbacks();
  const t = useTranslations();
  const prevRef = useRef<HTMLButtonElement | null>(null);
  const nextRef = useRef<HTMLButtonElement | null>(null);

  return (
    <div className="space-y-5.5 my-20">
      <div className="text-center text-2xl font-bold text-gray-800">{t('fikr_mulohazalar')}</div>

      <Swiper
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current
        }}
        slidesPerView="auto"
        modules={[FreeMode, Autoplay, Navigation]}
        onInit={swiper => {
          if (swiper.params.navigation) {
            const nav = swiper.params.navigation as any;

            nav.prevEl = prevRef.current;
            nav.nextEl = nextRef.current;
            swiper.navigation.init();
            swiper.navigation.update();
          }
        }}
        autoplay
        speed={4000}
        loop
        freeMode
        spaceBetween={16}
      >
        {feedbacks?.map(item => (
          <SwiperSlide key={item?.id} className="min-w-84 max-w-84">
            <Card item={item} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="flex items-center justify-center">
        <div className="flex items-center gap-2">
          <button
            ref={prevRef}
            aria-label="Previous slide"
            className="z-30 cursor-pointer rounded-full bg-white p-2 shadow-md"
          >
            <SwiperArrowLeftIcon />
          </button>
          <button
            ref={nextRef}
            aria-label="Next slide"
            className="z-30 cursor-pointer rounded-full bg-white p-2 shadow-md"
          >
            <SwiperArrowRightIcon />
          </button>
        </div>
      </div>
    </div>
  );
};
